import type { ColumnOrColumnGroup } from '@talos/kyoko';
import { getPriceGridCustomerMarketDataRequestParams, PRICE_GRID_MARKET_DATA_COLLECTION_PATH } from '../../columns';
import { PRICE_GRID_CUSTOMER_MARKET_DATA_COLUMN_TYPE } from '../../columns/constants';
import { getPriceGridCustomerMarketDataPriceColumn } from '../../columns/priceGridMarketDataPriceColumn';
import { getPriceGridMarketDataColumn, getPriceGridMarketDataColumnDynamics } from '../../hooks/dynamics';

const CUSTOMER_SECURITY_MARKET_DATA_SYMBOL_COL_ID = 'CustomerSecurityMarketData-Symbol';
const MARKET_SECURITY_MARKET_DATA_SYMBOL_COL_ID = 'MarketSecurityMarketData-Symbol';

export function getCustomerPriceGridColumns({
  counterparty,
  isBBOEnabled,
  showRFQ,
}: {
  counterparty: string | undefined;
  isBBOEnabled: boolean;
  showRFQ: boolean;
}): ColumnOrColumnGroup[] {
  return [
    {
      type: 'productType',
      id: 'ProductType',
      field: 'security.Symbol',
      title: 'Product',
      initialWidth: 120,
    },
    {
      type: 'text',
      id: 'Quantity',
      field: 'bucket.size',
      title: 'Qty',
      initialWidth: 100,
      suppressColumnsToolPanel: true,
    },
    getPriceGridCustomerMarketDataPriceColumn({
      type: PRICE_GRID_CUSTOMER_MARKET_DATA_COLUMN_TYPE,
      id: CUSTOMER_SECURITY_MARKET_DATA_SYMBOL_COL_ID,
      field: 'security.Symbol',
      title: 'Customer Price',
      initialWidth: 260,
      params: {
        marketDataCollectionPath: PRICE_GRID_MARKET_DATA_COLLECTION_PATH,
        getRequestParams: context => {
          if (!counterparty) {
            return undefined;
          }

          return {
            Counterparty: counterparty,
            ...getPriceGridCustomerMarketDataRequestParams(context),
          };
        },
        sizeBucketField: 'bucket.size',
      },
    }),
    getPriceGridMarketDataColumn(
      getPriceGridMarketDataColumnDynamics({
        colID: MARKET_SECURITY_MARKET_DATA_SYMBOL_COL_ID,
        title: 'Market Price',
      }),
      undefined,
      { includeRFQColumn: showRFQ, isBBOEnabled }
    ),
  ];
}
